import { inject } from '@angular/core';
import { StrakitDatetimeFormats } from '@ngx-strakit/cdk/controls';
import { DEFAULT_DATE_TIME_FORMAT, IrisTimeSandbox } from './time.sandbox';

const YEAR_INPUT = 'yyyy';
const MONTH_INPUT = 'yyyy-MM';
const MONTH_YEAR_LABEL = 'MMM yyyy';
const DATE_A11Y_LABEL = 'DDD';
const MONTH_YEAR_A11Y_LABEL = 'MMMM yyyy';
const POPUP_HEADER_DATE_LABEL = 'dd LLL, EEE';
const DEFAULT_DATE_FORMAT = 'dd.MM.yyyy';
const DEFAULT_TIME_FORMAT = 'HH:mm:ss';

function hasSeconds(datetimeFormat: string): boolean {
  return datetimeFormat.includes(':ss');
}

function hasMinutes(datetimeFormat: string): boolean {
  return datetimeFormat.includes('mm');
}

function addSeconds(datetimeFormat: string): string {
  return !hasSeconds(datetimeFormat) && hasMinutes(datetimeFormat) ? datetimeFormat.replace(/mm/, 'mm:ss') : datetimeFormat;
}

function removeSeconds(datetimeFormat: string): string {
  return hasSeconds(datetimeFormat) ? datetimeFormat.replace(/:ss/, '') : datetimeFormat;
}

export function datetimeFormatsFactory(): StrakitDatetimeFormats {
  const timeSandbox = inject(IrisTimeSandbox);
  // currentUser*Format getters can resolve to undefined while the user's time formats are still loading,
  // so fall back to sensible defaults instead of throwing and breaking the datetime controls.
  const timeFormat = timeSandbox.currentUserTimeFormat?.luxonFormatString || DEFAULT_TIME_FORMAT;
  const dateTimeFormat = timeSandbox.currentUserDateTimeFormat?.luxonFormatString || DEFAULT_DATE_TIME_FORMAT;
  const dateFormat = timeSandbox.currentUserDateFormat?.luxonFormatString || DEFAULT_DATE_FORMAT;

  return {
    parse: {
      dateInput: dateFormat,
      datetimeInput: removeSeconds(dateTimeFormat),
      longDatetimeInput: addSeconds(dateTimeFormat),
      timeInput: timeFormat,
      monthInput: MONTH_INPUT,
      yearInput: YEAR_INPUT,
    },
    display: {
      dateInput: dateFormat,
      datetimeInput: removeSeconds(dateTimeFormat),
      longDatetimeInput: addSeconds(dateTimeFormat),
      timeInput: timeFormat,
      monthInput: MONTH_INPUT,
      yearInput: YEAR_INPUT,
      monthYearLabel: MONTH_YEAR_LABEL,
      dateA11yLabel: DATE_A11Y_LABEL,
      monthYearA11yLabel: MONTH_YEAR_A11Y_LABEL,
      popupHeaderDateLabel: POPUP_HEADER_DATE_LABEL,
    },
  };
}
